// extracted by mini-css-extract-plugin
module.exports = {"prod-gift":"_23g3Rjch","prodGift":"_23g3Rjch","prod-gift-icon":"_2pIFwvZZ","prodGiftIcon":"_2pIFwvZZ","prod-gift-text":"_1mtMB6Aa","prodGiftText":"_1mtMB6Aa"};